export const GROWTH_PLAN_SSO_PRICE_ID = 'growth-sso-v1-USD-Monthly'
export const GROWTH_PLAN_PRICE_ID = 'growth-v1-USD-Monthly'
